import { isCurrencyISO } from '@/constants/currencies';

import type { Row } from '../../components/Table/constants';
import type { Transaction } from '../../hooks';

export const getTableDataFromTransactions = (
  transactions: Transaction[]
): Row[] => {
  return transactions.map((transaction) => {
    return {
      ticker: {
        exchangeCode: transaction.exchangeCode,
        symbol: transaction.symbol,
        companyName: transaction.holding?.providerCompanyName ?? null,
      },
      date: new Date(transaction.transactionDate),
      shares: transaction.units,
      price: transaction.amount,
      cost: transaction.amount * transaction.units,
      type: transaction.type.toLowerCase(),
      currencyISO: isCurrencyISO(transaction.currencyISO)
        ? transaction.currencyISO
        : null,
    };
  });
};
